module.exports = __webpack_public_path__ + "img/download.65771aa0.png";